// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"d357401a","787":"ddbbc0fd"}[chunkId] + ".chunk.js";
};